export const initialAbility = [
  {
    action: 'read',
    subject: 'public',
  },
]

export const _ = undefined
